import React from "react";
import styles from "./SelectAddressBottomSheet.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  addressEditModeToggleAction,
  setActionableAddressIdAction,
  setActiveAddressAction,
} from "../../../PhysicalAddress/store/actions";
import { useEffect } from "react";
import {
  showDeleteAddressPopupAction,
  showSelectAddressBottomSheetAction,
} from "../../store/actions";
import { useRouter } from "@src/lib/router";
import DashBorder from "../../../UIElements/DashBorder";

function AddressTemplate({
  lable,
  address1,
  address2,
  city,
  id,
  isDefault,
  landmark,
  name,
  mobile,
  pinCode,
  state,
  email,
  alternateNumber,
}) {
  // ROUTER
  const router = useRouter();
  // TRANSLATOR
  const { t } = useTranslation();
  //   DATA
  const data = {
    lable,
    address1,
    address2,
    city,
    id,
    isDefault,
    landmark,
    name,
    mobile,
    pinCode,
    state,
    email,
    alternateNumber
  };
  //   DISPATCH
  const dispatch = useDispatch();

  const selectAddress = () => {
    dispatch(setActiveAddressAction(data));
  };

  const deleteAddress = (id) => {
    dispatch(setActionableAddressIdAction(id));
    dispatch(showDeleteAddressPopupAction(true));
  };

  const editAddress = (data) => {
    dispatch(addressEditModeToggleAction(true));
    dispatch(setActiveAddressAction(data));
    dispatch(setActionableAddressIdAction(data?.id));

    router.push(`/${router?.query.courseId}/physicaladdress`);
    dispatch(showSelectAddressBottomSheetAction(false));
  };
  // SELECTORS
  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );

  const pincodeErrorMsg = useSelector(
    (state) => state?.physicalShipmentReducer?.picodeErrorMessage
  );
  const pincode = useSelector(
    (state) => state?.physicalShipmentReducer?.pincode
  );
  const showPopup = useSelector(
    (state) => state?.bottomSheetReducer?.showDeleteAddressPopup
  );

  const isBooksAdded = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.isBooksAdded
  );

  const bundles = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.bundles
  );

  useEffect(() => {
    // console.log("OFFLINEMATERIAL--SHOWPOPUP", showPopup);
  }, [showPopup]);

  return (
    <div className={styles.SelectAddressBottomSheet__AddressList__Address}>
      <div
        className={
          styles.SelectAddressBottomSheet__AddressList__Address__heading
        }
        onClick={selectAddress}
      >
        <h1>{lable}</h1>
        <div>
          <input
            type="radio"
            name="address"
            checked={activeAddress?.id === id}
          />
        </div>
      </div>
      <DashBorder />
      <p
        className={
          styles.SelectAddressBottomSheet__AddressList__Address__detail
        }
        onClick={selectAddress}
      >
        {address1}, {address2 ? `${address2}, ` : ""}
        <br />
        {city}, {state}, {pinCode}
      </p>
      <p
        className={
          styles.SelectAddressBottomSheet__AddressList__Address__MobileNumber
        }
        onClick={selectAddress}
      >
        {t(
          "components.bottomSheets.components.selectAddressBottomSheet.phoneNumber",
          "Phone Number:"
        )}{" "}
        <span>{mobile}</span>
      </p>
      {alternateNumber ? <p
        className={
          styles.SelectAddressBottomSheet__AddressList__Address__MobileNumber
        }
        onClick={selectAddress}
      >
         {t(
          "components.bottomSheets.components.selectAddressBottomSheet.alternateNumber",
          "Alternate Phone Number:"
        )}{" "}
        <span>{alternateNumber}</span>
      </p> : null}
      {email ? (
        <p
          className={
            styles.SelectAddressBottomSheet__AddressList__Address__MobileNumber
          }
          onClick={selectAddress}
        >
          Email: <span>{email}</span>
        </p>
      ) : null}
      <div
        className={
          styles.SelectAddressBottomSheet__AddressList__Address__button
        }
      >
        <button onClick={() => editAddress(data)}>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.edit",
            "Edit"
          )}
        </button>
        <button onClick={() => deleteAddress(id)}>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.delete",
            "Delete"
          )}
        </button>
      </div>
      {activeAddress?.pinCode == pincode && activeAddress?.id === id ? (
        <p className={styles.Errormsg}>{pincodeErrorMsg?.split(",")[0]}</p>
      ) : null}
      {bundles?.length > 0 &&
        !activeAddress?.email &&
        isBooksAdded &&
        activeAddress?.id === id ? (
        <p className={styles.Errormsg}>Email address is required</p>
      ) : null}
    </div>
  );
}

export default AddressTemplate;
